import React from 'react'
import CurvedMenuToggle from '../../components/curvedToggleMenu/CurvedMenuToggle'


function TestCurvedMenu() {
  return (
    <>
      <div className='fullpage' style={{backgroundColor:"yellow"}}>


        <div style={{padding:'20px',background:"green"}}  >
        {/* Your page content */}
          <h1>Welcome</h1>
          <p>Scroll content here...</p>

        </div>

        <CurvedMenuToggle
          curve="top"
          defaultOpen={true}
          menuColor="#e0e0e0"
          iconColor="#444"
        >
          <div
            style={{
              background: "#706c6cff",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              color: "#333",
            }}
          >
            <h3>My Section</h3>
            <p>This content block has its own independent styling.</p>
          </div>
        </CurvedMenuToggle>

        <div>
            <h2>This Content will be visible all the time</h2>
            <p>the quick brown fox jumps over the little lazy dog.</p>

        </div>

      </div>



    </>




  )
}

export default TestCurvedMenu
